export default "__VITE_ASSET__kmDxs7Do__"